export const YANDEX_METRIKA_ID = 97273184;
